import React from 'react';
import StarFilledIcon from '@atlaskit/icon/glyph/star-filled';
import { ff } from '@atlassian/jira-feature-flagging';
import { useIntl } from '@atlassian/jira-intl';
import { messages } from './messages';

const StarTitleCell = () => {
	const { formatMessage } = useIntl();
	return (
		<StarFilledIcon
			size="small"
			label={
				ff('a11y-jira-team.projects-directory-v3.enable-sorting-by-starred-column')
					? formatMessage(messages.starred)
					: ''
			}
		/>
	);
};

export default StarTitleCell;
